const POPULATE_VOUCHERS = "vouchers/populate-vouchers";
export default POPULATE_VOUCHERS;
